import type { AllRouteEndpoints } from "../routeTypes";

export const appGroupsAppGroupIdBannerPriority = "/app_groups/:app_group_id/banner_priority";

export const appGroupsAppGroupIdBannerPriorityCacheKeys: AllRouteEndpoints[] = [
  "/app_groups/:app_group_id/banner_priority",
  // A placement preview decides by priority, so a saved sort refetches an open one.
  "/app_groups/:app_group_id/placements/:id/preview",
];
